import React, { useState } from "react";
import "../Style/main.css";
import logo from "../Images/new-ai/logo.png";
import logoMb from "../Images/new-ai/logo-start.png";

// img

export default function Header() {
    const [linkLogin] = useState("https://gamev2.lsm99ai.online");
    const [linkRegister] = useState("https://gamev2.lsm99ai.online/register?partner=1291&channel=Xbgo");
    return (
        <>
            <div className="header-wrapper">
                <div className="head-group">
                    <a href={linkLogin}>
                        <div className="head-login">
                            <span>เข้าสู่ระบบ</span>
                        </div>
                    </a>

                    <div className="head-logo">
                        {/* <img src="https://assets.one-prod.com/web-assets/landingAi-new/Images/new-ai/logo.png" alt="logo" /> */}
                        <span className="pc"><img src={logo} alt="logo" /></span>
                        <span className="mb"><img src={logoMb} alt="logo" /></span>
                    </div>
                    <a href={linkRegister}>
                        <div className="head-register">สมัครสมาชิก</div>
                    </a>

                </div>
                <div className="head-group-mb">
                    <a href={linkLogin}>
                        <div className="head-login-mb"><span>เข้าสู่ระบบ</span></div>
                    </a>
                    <a href={linkRegister}>
                        <div className="head-register-mb">สมัครสมาชิก</div>
                    </a>
                </div>
            </div>
        </>
    );
}